<div *ngIf="currentOrg$ | async as currentOrg" class="appNav">
  <organizations-menu [currentOrg]="currentOrg"></organizations-menu>

  <!-- Tabs -->
  <div class="appNav-tabs">
    <!-- Letuchka -->
    <button
      class="appNav-tab"
      [class.active]="isTabsMode && isActiveTabLetuchka"
      [class.inactive]="isSettingsMode"
      [class.reverse-second]="defaultModule === defaultModuleTypes.SCREEN"
      (click)="switchTab(defaultModuleTypes.LETUCHKA)"
    >
      <img
        *ngIf="isActiveTabLetuchka; else grayLetuchkaLogo"
        src="/assets/images/glabix-logo-letuchka-76.png"
        alt="Летучка"
        width="16"
        height="16"
      />
      <ng-template #grayLetuchkaLogo>
        <div class="appNav-tab-logo flex-center-4">
          <span class="i i-glabix-letuchka"></span>
        </div>
      </ng-template>
      <span class="appNav-tab-label">{{ t("tabs.letuchka") }}</span>
    </button>
    <!-- Screen -->
    <button
      class="appNav-tab"
      [class.active]="isTabsMode && isActiveTabScreen"
      [class.inactive]="isSettingsMode"
      [class.reverse-first]="defaultModule === defaultModuleTypes.SCREEN"
      (click)="switchTab(defaultModuleTypes.SCREEN)"
    >
      <img
        *ngIf="isActiveTabScreen; else grayScreenLogo"
        src="/assets/images/glabix-logo-screen-76.png"
        alt="Экран"
        width="16"
        height="16"
      />
      <ng-template #grayScreenLogo>
        <div class="appNav-tab-logo flex-center-4">
          <span class="i i-glabix-screen"></span>
        </div>
      </ng-template>
      <span class="appNav-tab-label">{{ t("tabs.screen") }}</span>
    </button>
  </div>

  <!-- Profile -->
  <a
    *ngIf="isTabsMode"
    class="appNav-section"
    [routerLink]="['org', currentOrg.id, 'users', currentUser.id]"
    routerLinkActive="is-active"
  >
    <avatar class="absolute-center left-4" [user]="currentUser" [customClass]="'avatar-5'"></avatar>
    <span class="appNav-menu-title text-overflow" routerLinkActive="is-active" [innerHTML]="currentUser.name"></span>
  </a>

  <!-- Screen Tab Content -->
  <ng-container *ngIf="isTabsMode && activeTab === defaultModuleTypes.SCREEN">
    <!-- Recorder library -->
    <a
      class="appNav-section"
      [class.is-active]="isLibraryActive()"
      [routerLink]="['recorder', 'org', currentOrg.id, 'library']"
    >
      <span class="appNav-section-icon i i-glabix-screen"></span>
      <span class="appNav-menu-title" [class.is-active]="isLibraryActive()">
        {{ t("recorderLibrary") }}
      </span>
    </a>

    <!-- Screenshots -->
    <a
      class="appNav-section"
      [routerLink]="['recorder', 'org', currentOrg.id, 'library', 'screenshots']"
      routerLinkActive="is-active"
    >
      <span class="appNav-section-icon i i-screenshot"></span>
      <span class="appNav-menu-title" routerLinkActive="is-active">{{ t("screenshots") }}</span>
    </a>

    <!-- Leads -->
    <a
      class="appNav-section"
      [routerLink]="['recorder', 'org', currentOrg.id, 'library', 'forms']"
      routerLinkActive="is-active"
    >
      <span class="appNav-section-icon i i-user-group"></span>
      <span class="appNav-menu-title" routerLinkActive="is-active">{{ t("leads") }}</span>
    </a>

    <!-- Analytics -->
    <a
      class="appNav-section"
      [routerLink]="['recorder', 'org', currentOrg.id, 'library', 'analytics']"
      routerLinkActive="is-active"
    >
      <span class="appNav-section-icon i i-chart-gantt"></span>
      <span class="appNav-menu-title" routerLinkActive="is-active">{{ t("analytics") }}</span>
    </a>
  </ng-container>

  <!-- Letuchka Tab Content -->
  <ng-container *ngIf="isTabsMode && activeTab === defaultModuleTypes.LETUCHKA">
    <!-- Daily -->
    <a class="appNav-section" [routerLink]="['org', currentOrg.id, 'daily']" routerLinkActive="is-active">
      <span class="appNav-section-icon i i-calendar-lines-pen"></span>
      <span class="appNav-menu-title" routerLinkActive="is-active">{{ t(mode + "daily") }}</span>
    </a>

    <!-- Stream -->
    <a
      *ngIf="currentOrganization.team_mode"
      class="appNav-section"
      [routerLink]="['org', currentOrg.id, 'stream']"
      routerLinkActive="is-active"
    >
      <span
        class="appNav-section-icon i i-messages -top-after-0.5"
        [class.bullet-notification]="streamUnreadCheckService.orgHasUnread"
      ></span>
      <span class="appNav-menu-title" routerLinkActive="is-active">{{ t(mode + "stream") }}</span>
    </a>

    <!-- All Tasks -->
    <a class="appNav-section" [routerLink]="['org', currentOrg.id, 'tasks']" routerLinkActive="is-active">
      <span class="appNav-section-icon i i-memo-circle-check-2"></span>
      <span class="appNav-menu-title" routerLinkActive="is-active">{{ t(mode + "allTasks") }}</span>
    </a>

    <!-- Fav Projects -->
    <projects-menu
      class="h-full"
      [projects]="favoriteProjects$ | async"
      (onUpdateFavoritePosition)="updateFavoritePosition($event)"
    ></projects-menu>
  </ng-container>

  <!-- Settings Menu Content -->
  <div *ngIf="isSettingsMode" class="h-full -ml-1">
    <ng-scrollbar #scrollbarRef [position]="'invertY'" [visibility]="'hover'">
      <div scrollViewport cdkScrollable>
        <div class="flex flex-col ml-1">
          <a
            class="appNav-section"
            [routerLink]="['/org', currentOrg.id, 'settings']"
            routerLinkActive="is-active"
            [routerLinkActiveOptions]="rlao"
          >
            <span class="appNav-section-icon i i-gear"></span>
            <span
              class="appNav-menu-title appNav-menu-title-settings"
              routerLinkActive="is-active"
              [routerLinkActiveOptions]="rlao"
            >
              {{ t("settingsMenu.account") }}
            </span>
          </a>
          <a
            *ngIf="currentOrganization.team_mode && (canManageUsers$ | async) && !currentOrg.saml_enabled"
            class="appNav-section"
            [routerLink]="['org', currentOrg.id, 'settings', 'invitations', 'new']"
            routerLinkActive="is-active"
          >
            <span class="appNav-section-icon i i-user-plus"></span>
            <span class="appNav-menu-title appNav-menu-title-settings" routerLinkActive="is-active">{{
              t("settingsMenu.invite")
            }}</span>
          </a>
          <a
            *ngIf="canManageFinances$ | async"
            class="appNav-section"
            [routerLink]="['/org', currentOrg.id, 'settings', 'payments']"
            routerLinkActive="is-active"
          >
            <span class="appNav-section-icon i i-credit-card"></span>
            <span class="appNav-menu-title appNav-menu-title-settings" routerLinkActive="is-active">
              {{ t("settingsMenu.payments") }}
            </span>
          </a>
          <a
            *ngIf="isOrgOwner$ | async"
            class="appNav-section"
            [routerLink]="['/org', currentOrg.id, 'settings', 'organization']"
            routerLinkActive="is-active"
          >
            <span class="appNav-section-icon i i-house-2"></span>
            <span class="appNav-menu-title appNav-menu-title-settings" routerLinkActive="is-active">
              {{ t("settingsMenu.organization") }}
            </span>
          </a>
          <a
            *ngIf="currentOrganization.team_mode && (canManageDepartments$ | async)"
            class="appNav-section"
            [routerLink]="['/org', currentOrg.id, 'settings', 'departments']"
            routerLinkActive="is-active"
          >
            <span class="appNav-section-icon i i-diagram-project"></span>
            <span class="appNav-menu-title appNav-menu-title-settings" routerLinkActive="is-active">
              {{ t("settingsMenu.departments") }}
            </span>
          </a>
          <a
            *ngIf="currentOrganization.team_mode && (canManageUsers$ | async)"
            class="appNav-section"
            [routerLink]="['/org', currentOrg.id, 'settings', 'users']"
            routerLinkActive="is-active"
          >
            <span class="appNav-section-icon i i-user-group"></span>
            <span class="appNav-menu-title appNav-menu-title-settings" routerLinkActive="is-active">
              {{ t("settingsMenu.users") }}
            </span>
          </a>
          <a
            *ngIf="currentOrganization.team_mode && (canManageRoles$ | async)"
            class="appNav-section"
            [routerLink]="['/org', currentOrg.id, 'settings', 'roles']"
            routerLinkActive="is-active"
          >
            <span class="appNav-section-icon i i-clipboard-user"></span>
            <span class="appNav-menu-title appNav-menu-title-settings" routerLinkActive="is-active">
              {{ t("settingsMenu.roles") }}
            </span>
          </a>
          <a
            *ngIf="currentOrganization.team_mode && (canManageProjectRoles$ | async)"
            class="appNav-section"
            [routerLink]="['/org', currentOrg.id, 'settings', 'project_roles']"
            routerLinkActive="is-active"
          >
            <span class="appNav-section-icon i i-project-roles"></span>
            <span class="appNav-menu-title appNav-menu-title-settings" routerLinkActive="is-active">
              {{ t("settingsMenu.projectRoles") }}
            </span>
          </a>
          <!-- Team -->
          <a
            *ngIf="currentOrganization.team_mode"
            class="appNav-section"
            [routerLink]="['org', currentOrg.id, 'settings', 'teams']"
            routerLinkActive="is-active"
          >
            <span class="appNav-section-icon i i-team"></span>
            <span class="appNav-menu-title appNav-menu-title-settings" routerLinkActive="is-active">
              {{ t("settingsMenu.teams") }}
            </span>
          </a>
          <a
            class="appNav-section"
            [routerLink]="['/org', currentOrg.id, 'settings', 'loyalty-program']"
            routerLinkActive="is-active"
          >
            <span class="appNav-section-icon i i-loyalty"></span>
            <span class="appNav-menu-title appNav-menu-title-settings" routerLinkActive="is-active">
              {{ t("settingsMenu.loyaltyProgram") }}
            </span>
          </a>
          <a
            *ngIf="currentOrganization.team_mode"
            class="appNav-section"
            [routerLink]="['/org', currentOrg.id, 'settings', 'notifications']"
            routerLinkActive="is-active"
          >
            <span class="appNav-section-icon i i-envelope"></span>
            <span class="appNav-menu-title appNav-menu-title-settings" routerLinkActive="is-active">
              {{ t("settingsMenu.notifications") }}
            </span>
          </a>
          <a
            class="appNav-section"
            [routerLink]="['/org', currentOrg.id, 'settings', 'integrations']"
            routerLinkActive="is-active"
          >
            <span class="appNav-section-icon i i-telegram"></span>
            <span class="appNav-menu-title appNav-menu-title-settings" routerLinkActive="is-active">
              {{ t("settingsMenu.integrations") }}
            </span>
          </a>
          <!-- Branding -->
          <a
            *ngIf="(isOrgOwner$ | async) && currentOrganization.team_mode"
            class="appNav-section"
            [routerLink]="['/org', currentOrg.id, 'settings', 'branding']"
            routerLinkActive="is-active"
          >
            <span class="appNav-section-icon i i-paintbrush-pencil"></span>
            <span class="appNav-menu-title appNav-menu-title-settings" routerLinkActive="is-active">{{
              t("settingsMenu.branding")
            }}</span>
          </a>
          <!-- Lead Form Policies -->
          <a
            class="appNav-section"
            [routerLink]="['/org', currentOrg.id, 'settings', 'lead-form-policies']"
            routerLinkActive="is-active"
          >
            <span class="appNav-section-icon i i-file-pdf"></span>
            <span class="appNav-menu-title appNav-menu-title-settings" routerLinkActive="is-active">{{
              t("settingsMenu.leadFormPolicies")
            }}</span>
          </a>
          <!-- SSO -->
          <a
            *ngIf="(canManageRoles$ | async) && currentOrganization.saml_enabled"
            class="appNav-section"
            [routerLink]="['/org', currentOrg.id, 'settings', 'sso']"
            routerLinkActive="is-active"
          >
            <span class="appNav-section-icon i i-lock"></span>
            <span class="appNav-menu-title appNav-menu-title-settings" routerLinkActive="is-active">{{
              t("settingsMenu.sso")
            }}</span>
          </a>
        </div>
      </div>
    </ng-scrollbar>
  </div>

  <div class="mt-auto mb-2">
    <!-- Support -->
    <a class="appNav-section flex" [routerLink]="['org', currentOrg.id, 'support']" routerLinkActive="is-active">
      <span class="appNav-section-icon i i-messages-question"></span>
      <span class="appNav-menu-title font-normal normal-case w-full" routerLinkActive="is-active">
        {{ t("support") }}
      </span>
    </a>

    <!-- Settings -->
    <button *ngIf="isTabsMode" class="appNav-section flex w-full" (click)="openSettingsMenu()">
      <span class="appNav-section-icon i i-gear"></span>
      <span class="appNav-menu-title font-normal normal-case w-full">
        {{ t("settings") }}
      </span>
    </button>

    <div class="appNav-flex">
      <!-- Sign out -->
      <button class="appNav-section w-full" (click)="handleSignOut()">
        <span class="appNav-section-icon i i-arrow-right-from-bracket"></span>
        <span class="appNav-menu-title font-normal normal-case">{{ t("signOut.title") }}</span>
      </button>

      <!-- Toggle folding -->
      <button class="appNav-section appNav-toggle flex-center-8" (click)="toggle()">
        <span class="i i-chevron-left"></span>
      </button>
    </div>
  </div>
</div>
